import styled from 'styled-components';

export const Container = styled.section`
  margin: 20px 0;
`;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CashPoints/styles.js